import { getLimitedContentAccess } from '../../domain/Customer/ContentLimits'
import { useAccountsStore } from '../../store/AccountsStore'
import { ContentAccess, useMemberAccessPolicy } from './useMemberAccessPolicy'

/** The free plan limits the front applied on its own before the backend reported them. */
const FREE_PLAN_CONTENT_FALLBACK: ContentAccess = {
  isUnlimited: false,
  maxDocumentsPerAnimal: 1,
  maxHealthEntriesPerAnimal: 3,
}

/** The per-animal limits of the connected organization, or null when it is not limited. */
export const useLimitedContentAccess = (): ContentAccess | null => {
  const accountsStore = useAccountsStore()
  const { policy } = useMemberAccessPolicy(
    accountsStore.connectedAccount?.customerId,
    Boolean(accountsStore.connectedAccount)
  )

  if (policy?.content != null) {
    return getLimitedContentAccess(policy)
  }

  // Until the backend sends `content` (petso-backend#432), keep the previous rule: any `free` subscription.
  return accountsStore.isFree() ? FREE_PLAN_CONTENT_FALLBACK : null
}
